import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_58: DocMigration = {
  maxSchemaVersion: "0.0.58",
  description: "refactor Doc.Underlay to implement DocEntityBase",
  apply(json: any) {
    if (json.underlays) {
      migrateModelToExtendDocEntityBase(json, "underlays" as any);
    }
    return json;
  },
};

export default migration_0_0_58;
